import { render, staticRenderFns } from "./DxMonitoringDiseases.vue?vue&type=template&id=c34cd6d0&"
import script from "./DxMonitoringDiseases.vue?vue&type=script&lang=js&"
export * from "./DxMonitoringDiseases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports